import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { ignoreError } from '~/infra/utils';
export function logBIEventOld(id, data) {
    var _window_debug;
    if ((_window_debug = window.debug) === null || _window_debug === void 0 ? void 0 : _window_debug.logbi) {
        // eslint-disable-next-line no-console
        console.log('BI', id, data);
    }
    ignoreError(()=>{
        if (window._biHostname) {
            const blob = new Blob([
                JSON.stringify(_object_spread({
                    sessionId: window._sessionId,
                    viewportHeight: window.innerHeight,
                    viewportWidth: window.innerWidth
                }, data))
            ], {
                type: 'application/json'
            });
            navigator.sendBeacon("".concat(window._biHostname, "/bi/").concat(id), blob);
        }
    });
}
